import React from 'react';
import ProgressBar from '../../progress.bar';
import Footer from '../../Footer/footer';
import { getCampaignDefaults } from '../../../selectors';
import { connect } from 'react-redux';
import FAQ from '../../FAQ/faq';
import { faqContent, bankName, flexibleTerms } from './cobranding.customer.journey.data';

export class CoBrandingCustomerJourney extends React.Component {

  flexibleTerms(inputData) {
    return <div>
      {
        inputData.map((rowItem, rowIndex) => <div className="row" key={rowIndex}>
          {
            rowItem.row.map((item, index) => <div className="row col-12 col-sm-6 loan-benefits-row1" key={index}>
              <i className="material-icons text-barclays-primary check-icon" aria-hidden="true">check</i>
              <div className="small-progressbar font-weight-light">{item.title}
                <p className="h6 journey-steps">{item.description}</p>
              </div>
            </div>)
          }
        </div>)
      }
    </div>;
  }

  render() {
    const { campaignDefaults } = this.props;

    return (
      <div id="cobranded-page-customer-journey">
        <section className="the-journey">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <small className="text-uppercase headline-small">THE JOURNEY</small>
                <h2 className="text-darken-4 journey-desc">
                                    Three simple steps to get you closer to the money you need
                </h2>
              </div>
            </div>

            <div className="row text-center">
              <div className="col-12 d-none d-sm-block">
                <ProgressBar step="fullApp"/>
              </div>
            </div>

            <div className="row progressbar-description text-center">
              <div className="col-12 col-sm-4 journey-steps description-card">
                <div className="small-progressbar">Check your rate</div>
                                Lock in your APR up front. Checking your rate won't affect your credit score
              </div>
              <div className="col-12 col-sm-4 journey-steps description-card">
                <div className="small-progressbar">Select your loan term</div>
                                Choose the duration of the loan to receive your guaranteed rate. Your
                                approved loan amount and monthly payment will be determined upon review of your
                                application
              </div>
              <div className="col-12 col-sm-4 journey-steps description-card">
                <div className="small-progressbar">Apply for loan</div>
                                Funds will be disbursed a few business days after you accept the loan offer
              </div>
            </div>
          </div>
        </section>

        <section className="rates">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6">
                <div className="content">
                  <small className="headline-small">OUR RATES</small>
                  <h2 className="text-darken-4 journey-desc">
                                        Competitively low rates keep more money in your pocket
                  </h2>
                  <p>
                                        Stop paying high interest charges and start saving!
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6">
                <div className="card z-depth-5 text-center">
                  <div>
                    <p className="headline-small">APRS RANGE FROM</p>
                    <h3 className="text-darken-4 d-flex justify-content-center align-items-center">
                      <strong className="aprs-range">{campaignDefaults.minApr}<sup className="h6">%</sup></strong>&nbsp;
                                            -&nbsp;<strong className="aprs-range">{campaignDefaults.maxApr}<sup
                        className="h6">%</sup></strong>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="example">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="content text-center">
                  <small className="text-uppercase headline-small">Example</small>
                  <h2 className="text-darken-4 journey-desc">
                                        A versatile loan that puts you in control
                  </h2>
                  <p>
                                        Manage your loan with a fixed monthly payment
                  </p>
                </div>
              </div>
            </div>
            <div className="row text-center blue-text darken-4">
              <div className="col-12 col-sm-3">
                <h3 className="aprs-range"><strong><sup className="h6">$</sup>10,000</strong></h3>
                <p className="grey-text">Loan amount</p>
              </div>
              <div className="d-flex align-items-center justify-content-center col-12 col-sm-1 at">
                <p className="journey-desc font-weight-bold">AT</p></div>
              <div className="col-12 col-sm-3">
                <h3 className="aprs-range"><strong>5.99<sup className="h6">%</sup></strong></h3>
                <p className="grey-text">APR</p>
              </div>
              <div className="col-12 col-sm-1">
                <h3 className="journey-desc equal">=</h3></div>
              <div className="col-12 col-sm-3">
                <h3 className="payment-amount"><strong><sup className="h6">$</sup>236</strong></h3>
                <p className="grey-text required">Monthly payment <br/> over 48 months
                </p>
              </div>
            </div>

            <div className="row">
              <p className="grey-text col-12 col-md-8 offset-md-2 disclosure prefix-asterisk">The above
                                example is for
                                illustration purpose only.
                                Barclays Bank Delaware ({bankName}) offers loans from $5,000 – $35,000 with flexible
                                terms of 36, 48 and
                                60 months and APRs ranging from {campaignDefaults.minApr}% – {campaignDefaults.maxApr}%.
                                Your approved loan amount and
                                APR will be based on your creditworthiness and length of term requested.
              </p>
            </div>
          </div>
        </section>

        <div id="max-float">
          <section className="benefits">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="content">
                    <small className="headline-small">LOAN BENEFITS</small>
                    <h2 className="text-darken-4 journey-desc">
                                            The perfect combination to help you achieve your goals
                    </h2>
                    <p className="grey-text">
                                            Flexible terms put you in control
                    </p>
                  </div>
                </div>
              </div>

              {this.flexibleTerms(flexibleTerms)}

            </div>
          </section>

          <section className="faqs">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h2 className="text-darken-4 text-center journey-desc">{bankName} Personal Loan
                                        Q&amp;A</h2>
                  <br/>
                  <br/>
                  <div className="card">
                    <FAQ data={faqContent(campaignDefaults)}/>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="aprNote">
            <div className="container">
              <p id="cobranded-page-apr-foot-note">
                <sup className="h6"><a>1</a></sup>
                                Annual Percentage Rates range from {campaignDefaults.minApr}%
                                to {campaignDefaults.maxApr}% and will be determined based on your creditworthiness and
                                loan term. Loan amounts range from $5,000 to $35,000. Loan terms can be 36, 48 or 60
                                months.
              </p>
            </div>
          </section>

          <Footer showRewardsLink={true} />

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  campaignDefaults: getCampaignDefaults(state)
});

export default connect(mapStateToProps)(CoBrandingCustomerJourney);
